export default {"src":"/_next/static/media/original.d045f8d2.svg","blurWidth":0,"blurHeight":0};